/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import { Border, Colors } from '@zapier/theme';
import { Price } from '@zapier/design-system-revenue/src/components/other';

type AmountDueProps = {
  amountDue: number;
};

const invoiceTotalCss = css`
  color: ${Colors.deepSpace};
  display: flex;
  font-weight: 600;
  padding: 10px;

  &:not(:last-child) {
    border-bottom: ${Border.size.default} solid ${Border.color.default};
  }
`;

const invoiceTotalPriceCss = css`
  font-size: 1.3em;
  margin-left: auto; /* push the price to the right of the container */
  white-space: nowrap;
  padding-left: 20px;
`;

export const AmountDue = ({ amountDue }: AmountDueProps) => {
  const isRefund = amountDue < 0;

  return (
    <div css={invoiceTotalCss}>
      {isRefund
        ? 'Credit applied to your next invoice'
        : 'Amount being charged today'}
      <span css={invoiceTotalPriceCss}>
        <Price>{Math.abs(amountDue)}</Price>
      </span>
    </div>
  );
};
